import * as React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar, Chart } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
      display: false
    },
    title: {
      display: false
    },
  },
  scales: {
    y: {
      max: 1000,
      display: false
    },
    x: {
      display: false
    }
  }
};

const labels = [''];

class VerticalChart {
  get(value: number)
  {
    const d = {
      labels,
      datasets: [
        {
          data: labels.map(() => value),
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
          barThickness: 20
        }
      ]
    };
    return (
      <Bar options={options} data={d} />
    );
  }
}

export default VerticalChart;
